import TableActions from 'src/components/TableActions';

export default TableActions;
